import { getWeeksOfMonth } from '$tablet-app/src/app/utils/dateTime';
import { format } from 'date-fns';
import React, { FC } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Row from '../Row';
import MonthGridTile from './MonthGridTile';

interface Props {
  // The month to display
  date: Date;

  data: MonthGridData;

  style?: StyleProp<ViewStyle>;
}

export type MonthGridData = { [key: string]: MonthGridTileData };

export interface MonthGridTileData {
  date?: Date;
  success?: boolean;
}

const MonthGrid: FC<Props> = (props) => {
  const { date, style, data } = props;

  const weeks = getWeeksOfMonth(date);

  return (
    <View style={style}>
      {weeks.map((week, index) => (
        <Row
          key={'week-' + index}
          paddingVertical={8}
          alignItems="center"
          justifyContent="space-between"
        >
          {week.map((day, idx) => (
            <MonthGridTile
              key={idx}
              data={day ? data[format(day, 'yyyy-MM-dd')] : undefined}
              nextDay={
                week[idx + 1]
                  ? data[format(week[idx + 1] as Date, 'yyyy-MM-dd')]
                  : undefined
              }
            />
          ))}
        </Row>
      ))}
    </View>
  );
};

export default MonthGrid;
